/* eslint-disable no-console */
import axios from 'axios';
import HttpClient from './httpClient';
import Logger from './services/Logger';

class GetPresignURLController extends HttpClient {
  /**
   * getPresignedURL get's a user by it's userName.
   * @param {string} userName userName of the user
   * @param {string} token Auth token for Auth header
   * @returns {object} response data
   */

  getPresignedURL = async (data, token) => {
    try {
      const url = await this.client.post(`/getPresignedURL`, data, {
        headers: {
          Authorization: token,
        },
      });
      return url.data;
    } catch (err) {
      throw err;
    }
  };

  uploadDataToS3 = async (url, data) => {
    const options = {
      headers: {
        'Content-Type': data.type,
        'Access-Control-Allow-Origin': '*',
      },
    };
    try {
      const resp = await axios.put(url, data, options);
      return resp;
    } catch (err) {
      Logger.LogError(err);
      throw err;
    }
  };

  deleteImagesFromS3 = async (data, token) => {
    try {
      const url = await this.client.put(`/deleteImages`, data, {
        headers: {
          Authorization: token,
        },
      });
      return url;
    } catch (err) {
      throw err;
    }
  };
}

export default new GetPresignURLController(
  process.env.REACT_APP_API_BASE_URL_FILE_UPLOAD,
);
